// Node
require('noty/lib/noty');


Noty.overrideDefaults({
  theme: 'metroui',
  timeout: 3000
});

// Функция для рендеринга сообщений об ошибке
// type - тип: alert, success, error, warning, info
// msg - строка с сообщением об ошибке
const noty_render_alert = function(type, msg) {
  new Noty({
    type: type,
    text: msg.replace('\n', '<br>')
  }).show();
};

export { noty_render_alert }
